import React, { Component } from "react";
import { Container, Form, Modal } from "react-bootstrap"
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import Select from '../../../Components/PCSelect';
import WeekRangeSelect from '../../../Components/WeekRangeSelect';
import RemoveIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import { getISOWeek, formatDate, formatWeek, formatDisplayDate, getWeekDetails, deviceLabel, transactionStatus, sumMoney, displayStoredDate, partyLabel, formatAmount } from '../../../helper';
import ReactToPrint from 'react-to-print';
import SaleInvoiceReport from "../../../Report/SaleInvoiceReport";
import PhoneClinicGrid from "../../../Components/PhoneClinicGrid";
import RowActions from "../../../Components/PhoneClinicGrid/RowActions";
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES, ToggleSwitch } from '../shared/txStyles';
import StatusChip from '../shared/StatusChip';

import AmountInput from '../../../Components/AmountInput';
import PageHeader from '../shared/PageHeader';
import withRouter from '../../../helper/withRouter';
import { recordOpened, recordClosed, recordParamChanged, recordNotFound } from '../../../helper/recordLinks';
import RecordParty from '../shared/RecordParty';
import OwnEntityField from '../../../Components/OwnEntityField';
import { defaultOwnId } from '../../../helper/identity';

const BASE_PATH = '/admin/purchase-device';   // + '/<PUBLIC_ID>' opens one record (record links, Phase B)
class PurchaseDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The user's own shop this form works for (Phase 2): picked at the top when they have several.
            OWN_ID: defaultOwnId('shop', BASE_PATH),
            addPurchase: false,
            openModal: false,
            PurchaseInvoiceList: [],
            SaleToShop: "",
            SaleToVendor: "",
            EMAIL_TO: "",
            ShopList: [],
            PURCHASE_DATE: formatDate(new Date().toDateString()),
            PURCHASE_TO_TYPE: "Vendor",
            AddedItemList: [],
            Pur_Inv_Week: formatWeek(),
            AllVendorList: [],
            VendorList: [],
            shopPaymentDays: [],
            Item: {
                ItemType: "",
                ItemBrand: "",
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemSellRate: 0,
                ItemAmount: 0,
                ItemBulk: []
            },
            ItemList: [],

            repairTypeList: [
                { value: 'Phone', label: 'Phone' },
                { value: 'Tablet', label: 'Tablet' },
                { value: 'Laptop', label: 'Laptop' },
                { value: 'Gaming Console', label: 'Gaming Console' },
                { value: 'Watch', label: 'Watch' }
            ],
            repairBrandList: [],
            repairDeviceList: [],
            BulkImeiRender: [],
            BulkImei: "",
            BulkItemIndex: "",
            isdis: false,
            OTHER_DATA: localStorage.getItem('OTHER_DATA'),
        };
        this.gridRef = React.createRef(null);
    }

    async getAllPurchaseInv(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_SP_ID: this.ownId() || 0,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getSP = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetGridPurchaseInv.php`, formData);
        let ShopPaymentData = getSP.data
        let PurchaseInvoiceList = []
        if (ShopPaymentData.success === 1) {
            PurchaseInvoiceList = ShopPaymentData.data
            pagination.totalItems = parseInt(ShopPaymentData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ PurchaseInvoiceList })
        this.props.toggleLoader(false)
    }



    async getVenorList() {
        let formData = {
            PC_SP_ID: this.ownId() || 0,
            PC_GRP_ID: localStorage.getItem('PC_GRP_ID')
        }
        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCVendor.php`, formData);
        let deviceData = getDevice.data
        let AllVendorList = [], VendorList = []

        if (deviceData.success === 1) {
            AllVendorList = deviceData.data;
            for (let i = 0; i < AllVendorList.length; i++) {
                const vendr = AllVendorList[i];
                VendorList.push({
                    value: vendr.PC_VEN_ID,
                    label: vendr.PC_VEN_NAME
                })
            }
        }
        this.setState({ AllVendorList, VendorList })
    }

    async getInventoryList() {
        const getDevice = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllDevice.php`);
        let deviceData = getDevice.data
        let ItemList = []
        if (deviceData.success === 1) {
            for (let i = 0; i < deviceData.data.length; i++) {
                const items = deviceData.data[i];
                if (items !== "") {
                    ItemList.push({
                        value: items.DEVICE_ID,
                        label: items.DEVICE_NAME
                    })
                }
            }
        }
        this.setState({ ItemList })
    }

    async handleAddPurchaseInvoice() {
        let weekDetails = getWeekDetails();
        let shopPaymentDays = []
        if (weekDetails.dates.length > 0) {
            for (let i = 0; i < weekDetails.dates.length; i++) {
                const WeekPerDay = weekDetails.dates[i];
                shopPaymentDays.push({
                    'DateAndDay': WeekPerDay
                })
            }
        }


        this.setState({
            shopPaymentDays,
            Pur_Inv_Week: weekDetails.weekId,
            PURCHASE_DATE: formatDate(new Date().toDateString()),
            addPurchase: true,
            isEdit: false
        })
        this.getVenorList()

    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return Price
    }


    async handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item } = this.state;
        Item['ItemQuantity'] = 1
        switch (fieldName) {
            case 'ItemType':
                Item['ItemType'] = evt
                let deviceBrand = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceBrand.php`, { DEVICE: evt.value });
                let repairBrandList = []
                if (deviceBrand.data.success === 1) {
                    let devices = deviceBrand.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        const device = devices[i];
                        repairBrandList.push({
                            value: device.DEVICE_BRAND,
                            label: device.DEVICE_BRAND
                        })
                    }
                }
                this.setState({ repairBrandList })
                break;
            case "ItemBrand":
                Item['ItemBrand'] = evt
                let deviceType = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceName.php`, { BRAND: evt.value, DEVICE: Item['ItemType'].value });
                let repairDeviceList = []
                if (deviceType.data.success === 1) {
                    let devices = deviceType.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        const deviceName = devices[i];
                        repairDeviceList.push({
                            value: deviceName.DEVICE_NAME,
                            label: deviceName.DEVICE_NAME
                        })
                    }
                }
                this.setState({ repairDeviceList })
                break;

            case 'ItemName':
                Item['ItemName'] = evt
                Item['ItemRate'] = 0
                Item['ItemSellRate'] = 0
                Item['ItemAmount'] = 0
                break;

            case 'ItemQuantity':
                Item[fieldName] = evt.target.value
                Item['ItemAmount'] = parseFloat(evt.target.value * Item['ItemRate']).toFixed(2)
                break;
            case 'ItemRate':
                Item[fieldName] = evt.target.value
                Item['ItemAmount'] = parseFloat(Item['ItemQuantity'] * evt.target.value).toFixed(2)
                break;

            default:
                Item[fieldName] = evt.target.value
                break;

        }
        this.setState({ Item })
    }

    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.SP_NAME,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList })
    }

    async handleChange(fieldName, evt) {
        let target;
        switch (fieldName) {
            case 'PURCHASE_TO_TYPE':
                target = evt.target.value
                this.getShopList()
                break;
            case 'SaleToVendor':
            case 'SaleToShop':
                target = evt
                break;

            case "Pur_Inv_Week":
                target = evt.target.value
                let WeekNumber = evt.target.value;
                let weekYearArr = WeekNumber.split("-");
                weekYearArr[1] = weekYearArr[1].replace("W", "");
                let MappedValue = weekYearArr.map(n => parseInt(n)).reverse();
                let WeekOut = await getISOWeek(...MappedValue)
                let shopPaymentDays = [];
                let PURCHASE_DATE = "";
                if (WeekOut.length > 0) {
                    PURCHASE_DATE = formatDate(WeekOut[0]);
                    for (let i = 0; i < WeekOut.length; i++) {
                        const WeekPerDay = WeekOut[i];
                        shopPaymentDays.push({
                            'DateAndDay': WeekPerDay
                        })
                    }
                }
                this.setState({ shopPaymentDays, PURCHASE_DATE })
                break;

            default:
                target = evt.target.value
                break;
        }

        this.setState({ [fieldName]: target })

    }


    handleValidateItem(Item, AddedItemList) {
        let escapeImei = Item.ItemIMEI.replace(/\s+/g, '');
        if (Item.ItemType === '' || Item?.ItemType?.value === "") {
            Swal.fire(
                'Error',
                'Please select device',
                'error'
            )
            return false
        }
        if (Item.ItemBrand === '' || Item?.ItemBrand?.value === "") {
            Swal.fire(
                'Error',
                'Please select brand',
                'error'
            )
            return false
        }
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select item',
                'error'
            )
            return false
        }
        if (escapeImei === '') {
            Swal.fire(
                'Error',
                'Please enter IMEI',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseInt(Item.ItemRate) <= 0) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }

        for (let i = 0; i < AddedItemList.length; i++) {
            const ItemList = AddedItemList[i];
            if (escapeImei === ItemList.ItemIMEI) {
                Swal.fire(
                    'Error',
                    'Duplicate IMEI not allowed',
                    'error'
                )
                return false
            }
        }

        for (let j = 0; j < AddedItemList.length; j++) {
            const ItemList = AddedItemList[j];
            for (let k = 0; k < ItemList.ItemBulk.length; k++) {
                const ItemBulk = ItemList.ItemBulk[k];
                if (ItemBulk.BulkImei === escapeImei) {
                    Swal.fire(
                        'Error',
                        'Duplicate IMEI not allowed',
                        'error'
                    )
                    return false
                }
            }
        }
        return true
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleAddItem() {
        let { Item, AddedItemList } = this.state
        if (!this.handleValidateItem(Item, AddedItemList)) return
        let checkIfItemAvailable = AddedItemList.filter(x => x.ItemName.value === Item.ItemName.value)
        let CheckIndex = AddedItemList.findIndex(x => x.ItemName.value === Item.ItemName.value);
        if (checkIfItemAvailable.length > 0) {
            AddedItemList[CheckIndex]['ItemBulk'].push({
                BulkImei: Item['ItemIMEI']
            })
            this.setState({ AddedItemList })
        } else {
            let UpdateItemList = [Item].concat(AddedItemList)
            this.setState({ AddedItemList: UpdateItemList })
        }
        let RefreshItem = {
            ItemType: "",
            ItemBrand: "",
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemSellRate: 0,
            ItemAmount: 0,
            ItemBulk: []
        }
        this.setState({ Item: RefreshItem })

    }

    closeModal() {
        this.setState({ openModal: false })
    }

    handleClickBS(index) {
        let { AddedItemList } = this.state;
        let Item = AddedItemList[index]

        this.setState({
            openModal: true,
            BulkItemIndex: index,
            BulkImeiRender: Item['ItemBulk']
        })
    }

    handleEnterBulkImei(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddBulkItem()
        }
    }

    handleChangeBulkScan(evt) {
        this.setState({ [evt.target.name]: evt.target.value })
    }

    handleValidateUnique(AddedItemList, BulkIMEI) {
        let escapeImei = BulkIMEI.replace(/\s+/g, '');
        if (escapeImei === '') {
            Swal.fire(
                'Error',
                'Please enter IMEI',
                'error'
            )
            return false
        }

        for (let i = 0; i < AddedItemList.length; i++) {
            const itemList = AddedItemList[i];
            if (itemList.ItemIMEI === escapeImei) {
                Swal.fire(
                    'Error',
                    'Duplicate IMEI not allowed',
                    'error'
                )
                return false
            }
        }

        for (let j = 0; j < AddedItemList.length; j++) {
            const itemList = AddedItemList[j];
            for (let k = 0; k < itemList.ItemBulk.length; k++) {
                const ItemBulk = itemList.ItemBulk[k];
                if (ItemBulk.BulkImei === escapeImei) {
                    Swal.fire(
                        'Error',
                        'Duplicate IMEI not allowed',
                        'error'
                    )
                    return false
                }
            }
        }
        return true
    }
    // 7654567
    handleAddBulkItem() {
        let { BulkItemIndex, AddedItemList, BulkImei } = this.state;
        if (!this.handleValidateUnique(AddedItemList, BulkImei)) return
        let Item = AddedItemList[BulkItemIndex]
        Item.ItemBulk.push({ BulkImei })
        Item['ItemAmount'] = (Item.ItemBulk.length === 0 ? 1 : Item.ItemBulk.length + 1) * Item.ItemRate;
        this.setState({ AddedItemList, BulkImei: "" })
    }

    handleValidateData() {
        let { AddedItemList, PURCHASE_TO_TYPE } = this.state;

        if (PURCHASE_TO_TYPE === "Vendor" && this.state.SaleToVendor === "") {
            Swal.fire(
                'Error',
                'Please select Vendor',
                'error'
            )
            return false
        }

        if (PURCHASE_TO_TYPE === "Shop" && this.state.SaleToShop === "") {
            Swal.fire(
                'Error',
                'Please select Shop',
                'error'
            )
            return false
        }

        if (AddedItemList.length === 0) {
            Swal.fire(
                'Error',
                'Please add atleast 1 item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSave() {
        let { PURCHASE_TO_TYPE } = this.state;
        this.setState({ isdis: true })
        if (!this.handleValidateData()) return
        let formData = {
            PUR_INV_ID: "",
            PUR_INV_SHID: this.ownId() || 0,
            PUR_INV_DAYS: JSON.stringify(this.state.shopPaymentDays),
            PUR_INV_WEEK: this.state.Pur_Inv_Week,
            PUR_INV_TO: PURCHASE_TO_TYPE === "Vendor" ? this.state.SaleToVendor?.label : this.state.SaleToShop?.label,
            PUR_INV_TOTYPE: this.state.PURCHASE_TO_TYPE,
            PUR_INV_DATE: this.state.PURCHASE_DATE,
            PUR_INV_ITEM: JSON.stringify(this.state.AddedItemList),
            PUR_INV_NETAMT: this.renderTotalAmount()
        }
        try {

            let getPurInvRes = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/ShopModule/PCAddShopPurchase.php`, formData);

            if (getPurInvRes.data.status === 200) {
                Swal.fire(
                    'Success',
                    getPurInvRes.data.message,
                    'success'
                )
            } else {
                Swal.fire(
                    'Error',
                    getPurInvRes.data.message,
                    'error'
                )
            }
            this.handleExit()
            this.setState({ isdis: false })
        } catch (error) {
            this.setState({ isdis: false })
            console.error('error :>> ', error);
        }
    }

    handleExit() {
        recordClosed(this, BASE_PATH);
        this.recordOwner = null;
        this.setState({
            addPurchase: false,
            openModal: false,
            SaleToShop: "",
            PurchaseInvoiceList: [],
            SaleToVendor: "",
            EMAIL_TO: "",
            ShopList: [],
            PURCHASE_DATE: formatDate(new Date().toDateString()),
            PURCHASE_TO_TYPE: "Vendor",
            AddedItemList: [],
            Pur_Inv_Week: formatWeek(),
            AllVendorList: [],
            VendorList: [],
            shopPaymentDays: [],
            Item: {
                ItemType: "",
                ItemBrand: "",
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemSellRate: 0,
                ItemAmount: 0,
                ItemBulk: []
            },
            InventoryList: [],
            ItemList: [],

            repairTypeList: [
                { value: 'Phone', label: 'Phone' },
                { value: 'Tablet', label: 'Tablet' },
                { value: 'Laptop', label: 'Laptop' },
                { value: 'Gaming Console', label: 'Gaming Console' },
                { value: 'Watch', label: 'Watch' }
            ],
            repairBrandList: [],
            repairDeviceList: [],
            BulkImeiRender: [],
            BulkImei: "",
            BulkItemIndex: ""
        })
        this.getAllPurchaseInv()
    }


    /* ── Own shop (Phase 2, 2026-11-02) ──
     * A saved record works with ITS shop (set when it opens); a new one with the shop picked at
     * the top (OwnEntityField — only the user's own; one shop: shown, locked). */
    ownId() {
        return this.recordOwner || this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    // A different shop for the new record: its stock / vendors are reloaded and items already
    // added are cleared, so nothing from another shop is carried over.
    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id), AddedItemList: [] }, () => this.getVenorList());
    }

    /* ── Per-record links: /admin/purchase-device/<PUBLIC_ID> ── */
    componentDidMount() {
        const pid = this.props.params?.publicId;
        if (pid) this.openByPublicId(pid);
    }

    componentDidUpdate(prevProps) {
        recordParamChanged(this, prevProps, (pid) => this.openByPublicId(pid), () => this.handleExit());
    }

    // The record behind a link, from the same list endpoint with the server applying the signed-in
    // user's scope (only this shop's / warehouse's own records) — then the same form the list opens.
    async openByPublicId(pid) {
        this.openPid = pid;
        this.props.toggleLoader(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetGridPurchaseInv.php`, {
                PC_SP_ID: this.ownId() || 0, PUBLIC_ID: pid,
            });
            const row = res.data?.success === 1 ? res.data.data[0] : null;
            this.props.toggleLoader(false);
            if (!row) return recordNotFound(this, BASE_PATH);
            this.recordOwner = String(row.PUR_INV_SHID);
            await this.handleEdit(row);
        } catch (error) {
            this.props.toggleLoader(false);
            console.error('openByPublicId error:', error);
            recordNotFound(this, BASE_PATH);
        }
    }

    // The list's view / edit button: the same form as before, and the record's link in the address bar.
    openFromList(row) {
        recordOpened(this, BASE_PATH, row.PUBLIC_ID);
        this.recordOwner = String(row.PUR_INV_SHID);
        this.handleEdit(row);
    }

    async handleEdit(historyRow) {
        let Data = historyRow;
        let AddedItemList = []
        let getPurInvRes = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetDetailShopPurchaseInv.php`, {
            PC_SP_INV_SHID: this.ownId() || 0,
            PC_SP_INV_PUR_ID: Data.PUR_INV_ID
        });

        if (getPurInvRes.data.success === 1) {
            for (let i = 0; i < getPurInvRes.data.data.length; i++) {
                const ele = getPurInvRes.data.data[i];
                ele['ItemAmount'] = +ele['ItemRate']
                ele['ItemName'] = { value: ele['ItemName'], label: ele['ItemName'] }
            }
        }
        AddedItemList = getPurInvRes.data.data

        this.setState({
            isEdit: true,
            addPurchase: true,
            shopPaymentDays: JSON.parse(Data.PUR_INV_DAYS),
            Pur_Inv_Week: Data.PUR_INV_WEEK,
            PURCHASE_TO_TYPE: Data.PUR_INV_TOTYPE,
            SaleToVendor: { value: Data.PUR_INV_TO, label: Data.PUR_INV_TO },
            SaleToShop: { value: Data.PUR_INV_TO, label: Data.PUR_INV_TO },
            PURCHASE_DATE: Data.PUR_INV_DATE,
            AddedItemList
        })
    }

    handleRemove(index) {
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }

    handleRemoveBulk(index) {
        let { BulkItemIndex, AddedItemList } = this.state;
        let Item = AddedItemList[BulkItemIndex]
        Item.ItemBulk.splice(index, 1)
        this.setState({ AddedItemList, BulkImei: "" })
    }



    handleValidate() {
        if (this.state.EMAIL_TO === "") {
            Swal.fire(
                'Error',
                'Please Enter Email Address',
                'error'
            )
            return false
        }
        return true
    }

    async handleSendEmail() {
        let { PURCHASE_TO_TYPE } = this.state;
        if (!this.handleValidate()) return
        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: this.ownId(),
            SALE_CUSTOMER: PURCHASE_TO_TYPE === "Vendor" ? this.state.SaleToVendor?.label : this.state.SaleToShop?.label,
            SALE_WAREHOUSE: "",
            SALE_DESCRIPTION: "Thank you for purchasing!!!",
            SALE_DATE: this.state.PURCHASE_DATE,
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            EMAIL_TO: this.state.EMAIL_TO
        }

        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}mail/SendMailPurchase.php`, formData);

        if (getSaleInvoiceResult.data.status === 201) {
            Swal.fire(
                'Success',
                'Email has been send!!',
                'success'
            )
        }
    }


    render() {
        let { shopPaymentDays, Item } = this.state;
        const isLocked = this.state.isEdit;
        const weekLabel = shopPaymentDays.length > 0
            ? `${shopPaymentDays[0]['DateAndDay']} – ${shopPaymentDays[6]['DateAndDay']}`
            : '';

        if (!this.state.addPurchase) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        title="PURCHASE DEVICE"
                        buttonLabel="Add purchase"
                        ref={this.gridRef}
                        getData={this.getAllPurchaseInv.bind(this)}
                        onClickButton={this.handleAddPurchaseInvoice.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "PURCHASE FROM", isHidden: false },
                            { label: "DEVICE", isHidden: false },
                            { label: "STATUS", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Columns follow the shared sale/purchase standard:
                            DATE | SALE TO or PURCHASE FROM as "Name (Type)" | DEVICE (device screens) | STATUS | TOTAL PRICE. */}
                        {this.state.PurchaseInvoiceList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.PUR_INV_DATE)}</TableCell>
                                <TableCell>{partyLabel(row.PUR_INV_TO, row.PUR_INV_TOTYPE)}</TableCell>
                                <TableCell>{deviceLabel(row.PUR_INV_ITEM)}</TableCell>
                                <TableCell><StatusChip label={transactionStatus(row, 'purchase')} /></TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.PUR_INV_NETAMT)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'view', onClick: this.openFromList.bind(this, row) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Purchase By Shop" subtitle={weekLabel} right={<><ToggleSwitch
                        options={['Vendor', 'Shop']}
                        value={this.state.PURCHASE_TO_TYPE}
                        onChange={val => this.setState({ PURCHASE_TO_TYPE: val })}
                        disabled={isLocked}
                    /></>} style={{ margin: "0 0 16px" }} />

                {/* Input Card */}
                {/* The shop this record is for (Phase 2): own only; locked once saved. */}
                <OwnEntityField kind="shop" screen={BASE_PATH} value={this.ownId()} disabled={!!this.recordOwner || !!this.state.isEdit} onChange={this.handleOwnChange.bind(this)} />
                {/* A saved record: its party, date (and description) stay visible, disabled (2026-11-02). */}
                {isLocked && <RecordParty items={[{ label: this.state.PURCHASE_TO_TYPE ? `Purchase from (${this.state.PURCHASE_TO_TYPE})` : 'Purchase from', value: this.state.SaleToVendor && this.state.SaleToVendor.label }, { label: 'Date', value: displayStoredDate(this.state.PURCHASE_DATE) }]} />}
                {!isLocked && (
                    <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                        <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
                            <div>
                                <label style={LABEL}>Week</label>
                                <WeekRangeSelect menuPortalTarget={document.body} menuPlacement="auto" value={this.state.Pur_Inv_Week} onChange={this.handleChange.bind(this, 'Pur_Inv_Week')} />
                            </div>
                            <div>
                                <label style={LABEL}>{this.state.PURCHASE_TO_TYPE}</label>
                                {this.state.PURCHASE_TO_TYPE === 'Vendor'
                                    ? <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={this.state.SaleToVendor} options={this.state.VendorList} onChange={this.handleChange.bind(this, 'SaleToVendor')} />
                                    : <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={this.state.SaleToShop} options={this.state.ShopList} onChange={this.handleChange.bind(this, 'SaleToShop')} />
                                }
                            </div>
                            <div>
                                <label style={LABEL}>Date</label>
                                <input
                                    type="date"
                                    style={INPUT}
                                    value={this.state.PURCHASE_DATE}
                                    min={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[0]['DateAndDay']) : ''}
                                    max={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[6]['DateAndDay']) : ''}
                                    onChange={this.handleChange.bind(this, 'PURCHASE_DATE')}
                                />
                            </div>
                            <div>
                                <label style={LABEL}>Device</label>
                                <Select menuPortalTarget={document.body} styles={SELECT_STYLES} options={this.state.repairTypeList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemType')} value={Item['ItemType']} />
                            </div>
                            <div>
                                <label style={LABEL}>Brand</label>
                                <Select menuPortalTarget={document.body} styles={SELECT_STYLES} options={this.state.repairBrandList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemBrand')} value={Item['ItemBrand']} />
                            </div>
                            <div>
                                <label style={LABEL}>Item</label>
                                <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={Item['ItemName']} options={this.state.repairDeviceList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                            </div>
                            <div>
                                <label style={LABEL}>Buy Rate</label>
                                <AmountInput plain style={INPUT} value={Item['ItemRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemRate')} />
                            </div>
                            <div>
                                <label style={LABEL}>Sell Rate</label>
                                <AmountInput plain style={INPUT} value={Item['ItemSellRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemSellRate')} />
                            </div>
                            <div>
                                <label style={LABEL}>Qty.</label>
                                <input type="number" style={{ ...INPUT, background: '#f1f5f9', cursor: 'not-allowed' }} value={Item['ItemQuantity']} disabled onChange={this.handleChangeUpdatedItem.bind(this, 'ItemQuantity')} />
                            </div>
                        </div>
                        <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 16, alignItems: 'flex-end' }}>
                            <div>
                                <label style={LABEL}>IMEI No</label>
                                <input style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                            </div>
                            <div>
                                <label style={LABEL}>Description</label>
                                <input style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                            </div>
                            <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                        </div>
                    </div>
                )}

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small" className="pc-card-table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>BUY RATE</TableCell>
                                <TableCell style={COL_HEAD}>SELL RATE</TableCell>
                                <TableCell style={COL_HEAD}>QTY</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                {!isLocked && <TableCell style={COL_HEAD}>ACTION</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => {
                                let totalQuantity = !isLocked ? (ItemDetails.ItemBulk.length === 0 ? 1 : ItemDetails.ItemBulk.length + 1) : 1;
                                let totalAmount = ItemDetails.ItemRate * totalQuantity;
                                return (
                                    <TableRow key={idx}>
                                        <TableCell>
                                            {ItemDetails.ItemName?.label ? ItemDetails.ItemName.label : ItemDetails.ItemName}
                                            {!isLocked && <span style={{ marginLeft: 12, color: '#a32f2f', textDecoration: 'underline', cursor: 'pointer' }} onClick={this.handleClickBS.bind(this, idx)}>BS</span>}
                                        </TableCell>
                                        <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                        <TableCell>£ {formatAmount(ItemDetails.ItemRate)}</TableCell>
                                        <TableCell>£ {formatAmount(ItemDetails.ItemSellRate)}</TableCell>
                                        <TableCell>{totalQuantity}</TableCell>
                                        <TableCell>£ {formatAmount(totalAmount)}</TableCell>
                                        {!isLocked && (
                                            <TableCell>
                                                <IconButton size="small" onClick={this.handleRemove.bind(this, idx)}><RemoveIcon /></IconButton>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={5} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Purchase</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                {!isLocked && <td />}
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                        {!isLocked && (
                            <Button variant="contained" disabled={this.state.isdis} onClick={this.handleSave.bind(this)}>SAVE</Button>
                        )}
                    </div>
                    {isLocked && (
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                            <input style={{ ...INPUT, width: 200 }} value={this.state.EMAIL_TO} placeholder="Enter Email" onChange={this.handleChange.bind(this, 'EMAIL_TO')} />
                            <Button variant="outlined" onClick={this.handleSendEmail.bind(this)}>SEND EMAIL</Button>
                            <ReactToPrint
                                trigger={() => <Button variant="contained" color="tertiary" startIcon={<PrintIcon />}>PRINT</Button>}
                                content={() => this.printThermalSale}
                            />
                        </div>
                    )}
                </div>

                <SaleInvoiceReport
                    ref={el => (this.printThermalSale = el)}
                    data={{
                        ItemList: this.state.AddedItemList,
                        SaleDate: formatDisplayDate(this.state.PURCHASE_DATE),
                        SaleTo: this.state.PURCHASE_TO_TYPE === "Vendor" ? this.state.SaleToVendor?.label : this.state.SaleToShop?.label,
                        TotalAmount: this.renderTotalAmount(),
                        OTHER_DATA: this.state.OTHER_DATA
                    }}
                />

                <Modal show={this.state.openModal} onHide={this.closeModal.bind(this)} keyboard={false} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk Scan IMEI No</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>IMEI No</Form.Label>
                            <Form.Control
                                name="BulkImei"
                                value={this.state.BulkImei}
                                onKeyPress={this.handleEnterBulkImei.bind(this)}
                                onChange={this.handleChangeBulkScan.bind(this)}
                            />
                        </Form.Group>
                        <Table>
                            <TableBody>
                                {this.state.BulkImeiRender.map((bulk, bulkKeyIndex) => (
                                    <TableRow key={bulkKeyIndex}>
                                        <TableCell>{bulkKeyIndex + 1}</TableCell>
                                        <TableCell>{bulk.BulkImei}</TableCell>
                                        <TableCell>
                                            <IconButton size="small" onClick={this.handleRemoveBulk.bind(this, bulkKeyIndex)}><RemoveIcon /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Modal.Body>
                </Modal>
            </Container>
        );
    }
}

export default withRouter(PurchaseDevice);